import Skeleton from "react-loading-skeleton";
import "./ProductDetailSkeleton.css";

const ProductDetailSkeleton = () => (
  <div className="pdp-skeleton" aria-hidden="true" aria-busy="true">
    <nav className="pdp-breadcrumb pdp-skeleton__breadcrumb">
      <Skeleton width={48} height={14} borderRadius={4} />
      <span>/</span>
      <Skeleton width={72} height={14} borderRadius={4} />
      <span>/</span>
      <Skeleton width={160} height={14} borderRadius={4} />
    </nav>

    <div className="all-product-detail">
      <div className="wrapper pdp-skeleton__main-card">
        <div className="pdp-skeleton__gallery">
          <div className="pdp-skeleton__thumbs">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} width={56} height={56} borderRadius={10} />
            ))}
          </div>
          <div className="pdp-skeleton__hero">
            <Skeleton height="100%" borderRadius={12} />
          </div>
        </div>

        <div className="pdp-skeleton__info">
          <div className="pdp-skeleton__details">
            <Skeleton height={32} width="85%" borderRadius={8} />
            <div className="pdp-skeleton__chips">
              <Skeleton width={88} height={28} borderRadius={999} />
              <Skeleton width={110} height={28} borderRadius={999} />
            </div>
            <Skeleton height={28} width="38%" borderRadius={6} />
            <Skeleton width={120} height={24} borderRadius={999} />
            <Skeleton width={48} height={14} borderRadius={4} />
            <div className="pdp-skeleton__size-row">
              {Array.from({ length: 4 }).map((_, i) => (
                <Skeleton key={i} width={44} height={36} borderRadius={8} />
              ))}
            </div>
            <Skeleton width={72} height={14} borderRadius={4} />
            <div className="pdp-skeleton__qty-row">
              <Skeleton width={120} height={40} borderRadius={8} />
            </div>
            <div className="pdp-skeleton__actions">
              <Skeleton height={48} borderRadius={10} containerClassName="pdp-skeleton__cart-btn" />
              <Skeleton width={48} height={48} borderRadius={10} />
            </div>
            <Skeleton height={44} width="100%" borderRadius={8} />
          </div>

          <div className="pdp-skeleton__shipping">
            <Skeleton width={140} height={20} borderRadius={6} />
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="pdp-skeleton__shipping-row">
                <Skeleton circle width={36} height={36} />
                <div className="pdp-skeleton__shipping-text">
                  <Skeleton width="70%" height={16} borderRadius={4} />
                  <Skeleton width="90%" height={12} borderRadius={4} />
                  <Skeleton width="55%" height={12} borderRadius={4} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="pdp-skeleton__related">
        <Skeleton width={180} height={22} borderRadius={6} />
        <div className="pdp-skeleton__related-grid">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="pdp-skeleton__related-card">
              <Skeleton height={140} borderRadius={10} />
              <Skeleton width="80%" height={14} borderRadius={4} />
              <Skeleton width="50%" height={16} borderRadius={4} />
            </div>
          ))}
        </div>
      </div>

      <div className="pdp-skeleton__reviews">
        <Skeleton width={160} height={22} borderRadius={6} />
        <Skeleton width="40%" height={14} borderRadius={4} />
        <div className="pdp-skeleton__review-cards">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="pdp-skeleton__review-card">
              <Skeleton width={100} height={14} borderRadius={4} />
              <Skeleton width={80} height={12} borderRadius={4} />
              <Skeleton count={2} height={12} borderRadius={4} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default ProductDetailSkeleton;
